<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="baseCustomermaterialprices">
      <div slot="toolbar">
        <span slot="footer">
            <el-upload
                :action="uploadUrl"
                :headers="uploadHeaders"
                :before-upload="beforeAvatarUpload"
                :disabled="disabled"
                :on-error="handlerError"
                :on-exceed="onExceed"
                :on-progress="onProgress"
                :on-success="handleSuccess"
                :show-file-list="false"
                accept=".xlsx"
                style="display: inline-block;margin: 0 5px">
              <el-button type="primary" :loading="importLoading">导入</el-button>
            </el-upload>
          </span>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="蒂升料号">
            <el-input v-model.trim="filter.customerMaterialNo" clearable/>
          </vm-search>
          <vm-search label="蒂升图号">
            <el-input v-model.trim="filter.customerMaterialDrawNo" clearable/>
          </vm-search>
          <vm-search label="SAP物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="产品名称">
            <el-input v-model.trim="filter.productName" clearable/>
          </vm-search>
          <vm-search label="产品类别">
            <el-input v-model.trim="filter.productCategory" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="customerMaterialNo" align="center" label="蒂升物料号" width="200" fixed="left"/>
      <el-table-column prop="customerMaterialDrawNo" align="center" label="蒂升图号" width="200" fixed="left"/>
      <el-table-column prop="materialNo" align="center" width="150" label="SAP物料号"/>
      <el-table-column prop="productCategory" align="center" min-width="200" label="产品类别"/>
      <el-table-column prop="productName" align="center" min-width="200" label="产品名称"/>
      <el-table-column prop="netPrice" align="center" width="200" label="未税单价"/>
      <el-table-column prop="price" align="center" width="100" label="含税单价"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column prop="creatorName" align="center" width="80" label="创建人"/>
      <el-table-column prop="createTime" align="center" width="140" label="创建时间"/>
      <el-table-column
          label="操作"
          align="center" width="100" fixed="right"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <!--          <el-button type="primary" v-if="editAuth" :disabled="scope.row.status==1" @click="edit(scope.row,0)">编辑-->
          <!--          </el-button>-->
          <el-button type="danger" v-if="editAuth" :disabled="scope.row.status==1" @click="oneDelete(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import RuleCustomEdit from "@/views/RuleCustom/RuleCustomEdit.vue";

  export default {
    name: "CustomerMaterialPriceList",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        importLoading: false,
        exportLoading: false,
        editAuth: this.$auth(591),
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        uploadUrl: window.config.basicServerUrl + "baseCustomermaterialprices/importFile",
        disabled: false,
        filter: {
          customerMaterialDrawNo: "",
          customerMaterialNo: "",
          materialNo: "",
          creatorName: "",
          productName: "",
          productCategory: "",
          note: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "baseCustomermaterialprices/delete", ids).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      edit(row, isCopy) {
        this.$refs.editPage.open(row.pkid, isCopy);
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
